export default __webpack_public_path__ + "static/media/ProdirPicture.3aa00d6a.jpg";